module.exports = __webpack_public_path__ + "static/media/B-homeowners.0b25021d.png";